<template>
    <div class="homepage__hero">
        <div class="homepage__hero-wrap">
            <div class="homepage__hero-content">
                <div class="homepage__hero-content-wrap">
                    <h1 class="title">Engage your students in math practice</h1>
                    <div class="text">
                        <p>
                            Transform your math classes with 99math!
                            <br />
                            Empower your students to achieve
                            <span class="line-1">fact fluency,</span>
                            meet
                            <span class="line-2">curriculum standards,</span>
                            and develop a passion for math.
                            <br />
                            <br />
                            With group activities, individual practice, and
                            play-at-home games, your students will boost their
                            accuracy and confidence in math.
                        </p>
                    </div>
                </div>
                <div class="homepage__hero-signup">
                    <div class="homepage__hero-signup-wrap">
                        <router-link
                            v-if="country === 'USA'"
                            :to="{ name: 'teacher-register' }"
                        >
                            <button class="btn-register btn-register--teacher">
                                <span class="label">
                                    Teachers, full access for FREE
                                </span>
                                <span class="icon">
                                    <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M7.97702 23.6163L18.6669 12.9262C18.914 12.6792 19.0496 12.3498 19.0496 11.991C19.0496 11.6394 18.914 11.3098 18.6669 11.0632L7.98717 0.383023C7.73995 0.135999 7.41039 0 7.05878 0C6.70717 0 6.37742 0.135804 6.13039 0.383023L5.34386 1.16956C5.09684 1.41658 4.96045 1.74633 4.96045 2.09794C4.96045 2.44955 5.09684 2.77911 5.34386 3.02633L14.3122 11.9947L5.33352 20.973C5.08669 21.22 4.9505 21.5496 4.9505 21.9014C4.9505 22.253 5.08669 22.5823 5.33352 22.8296L6.12044 23.6163C6.63225 24.1279 7.46522 24.1279 7.97702 23.6163Z"
                                            fill="#572598"
                                        />
                                    </svg>
                                </span>
                            </button>
                        </router-link>
                        <router-link
                            v-else
                            :to="{
                                name: 'auth.register',
                                query: { role: 'teacher' },
                            }"
                        >
                            <button class="btn-register btn-register--teacher">
                                <span class="label">Teacher, start here</span>
                                <span class="icon">
                                    <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M7.97702 23.6163L18.6669 12.9262C18.914 12.6792 19.0496 12.3498 19.0496 11.991C19.0496 11.6394 18.914 11.3098 18.6669 11.0632L7.98717 0.383023C7.73995 0.135999 7.41039 0 7.05878 0C6.70717 0 6.37742 0.135804 6.13039 0.383023L5.34386 1.16956C5.09684 1.41658 4.96045 1.74633 4.96045 2.09794C4.96045 2.44955 5.09684 2.77911 5.34386 3.02633L14.3122 11.9947L5.33352 20.973C5.08669 21.22 4.9505 21.5496 4.9505 21.9014C4.9505 22.253 5.08669 22.5823 5.33352 22.8296L6.12044 23.6163C6.63225 24.1279 7.46522 24.1279 7.97702 23.6163Z"
                                            fill="#572598"
                                        />
                                    </svg>
                                </span>
                            </button>
                        </router-link>
                        <div class="homepage__hero-signup-links">
                            Sign up as
                            <router-link
                                :to="{
                                    name: 'auth.register',
                                    query: { role: 'student' },
                                }"
                            >
                                student
                            </router-link>
                            or
                            <router-link
                                :to="{
                                    name: 'auth.register',
                                    query: { role: 'parent' },
                                }"
                            >
                                parent
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="homepage__hero-video">
                <div class="homepage__hero-video-content">
                    <svg class="homepage__hero-video-clip">
                        <clipPath id="heroVideoClip">
                            <path
                                class="path-1"
                                d="M70.259 0H707.379C724.488 0 738.133 14.2862 737.347 31.3774L717.309 467.377C716.573 483.393 703.373 496 687.34 496H32.6958C15.1111 496 1.29708 480.945 2.80648 463.425L40.3697 27.4249C41.7062 11.912 54.6886 0 70.259 0Z"
                                fill="#C4C4C4"
                            />
                            <path
                                class="path-2"
                                d="M60.2651 0H534.597C551.706 0 565.351 14.2861 564.566 31.3773L549.859 351.377C549.122 367.393 535.923 380 519.89 380H32.6958C15.1111 380 1.29709 364.945 2.80649 347.425L30.3758 27.4249C31.7123 11.912 44.6947 0 60.2651 0Z"
                                fill="#C4C4C4"
                            />
                        </clipPath>
                    </svg>
                    <div class="homepage__hero-video-wrap">
                        <iframe
                            src="https://player.vimeo.com/video/835803017?autoplay=1&loop=1&muted=1&player_id=0&amp;app_id=58479&background=1"
                            frameborder="0"
                            allow="autoplay; fullscreen; picture-in-picture"
                            allowfullscreen
                            style="width: 100%; height: 100%"
                            title="99math"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { MobileScreenWidthDetect } from '@/core/mixins/MobileScreenWidthDetect';
import { supportWebPImage } from '@/core/helpers/utils';
import { mapGetters } from 'vuex';

export default {
    mixins: [MobileScreenWidthDetect],
    data: function () {
        return {
            windowWidth: 0,
        };
    },
    computed: {
        ...mapGetters({
            locale: 'getCurrentLanguage',
            country: 'getCountry',
        }),
    },
    watch: {
        isTabletScreenWidth() {
            this.changeImageIfNoWebPSupport();
        },
    },
    mounted() {
        this.windowWidth = window.innerWidth;

        window.addEventListener('resize', this.onResize);

        this.changeImageIfNoWebPSupport();
    },
    unmounted() {
        window.removeEventListener('resize', this.onResize);
    },
    methods: {
        onResize() {
            this.windowWidth = window.innerWidth;
        },
        changeImageIfNoWebPSupport() {
            if (!supportWebPImage()) {
                const videoTag = document.getElementById('hero-video');

                if (videoTag) {
                    videoTag.setAttribute('poster', '/images/lp/hero.png');
                }
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.homepage {
    &__hero {
        background-color: #572598;
        position: relative;
        width: 100%;
        overflow: hidden;
    }

    &__hero-wrap {
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        max-width: calc(1530px + 3rem);
        margin: 0 auto;
        padding: 3rem 1.5rem;

        @include mq($w-max-desktop, max) {
            max-width: calc(1190px + 3rem);
        }

        @include mq($w-max-tablet, max) {
            flex-direction: column;
            padding: 3rem 1.5rem;
        }

        @include mq($w-max-sm, max) {
            padding-top: 2.5rem;
            padding-bottom: 0;
        }
    }

    &__hero-content {
        box-sizing: border-box;
        flex: 1;
        display: flex;
        flex-direction: column;
        padding-right: 5rem;

        @include mq($w-max-desktop, max) {
            padding-right: 4rem;
        }

        @include mq($w-max-tablet, max) {
            align-items: center;
            order: 1;
            max-width: 570px;
            text-align: center;
            padding: 0;
        }

        .title {
            margin: 0 0 2rem;
            padding: 0;
            font-size: 56px;
            line-height: 60px;
            font-weight: 700;

            @include mq($w-max-desktop, max) {
                font-size: 46px;
                line-height: 54px;
            }

            @include mq($w-max-phone, max) {
                margin-bottom: 1rem;
                font-size: 30px;
                line-height: 130%;
                font-style: italic;
            }

            @include mq($h-max-incl-chromebook, max, height) {
                font-size: 2.5rem;
                line-height: normal;
                margin-bottom: 1rem;
            }
        }

        .text {
            margin: 0 0 3.5rem;
            padding: 0;
            font-weight: 500;
            font-size: 23px;
            line-height: 150%;

            @include mq($w-max-desktop, max) {
                margin-bottom: 3rem;
            }

            @include mq($w-max-phone, max) {
                margin-bottom: 2.5rem;
                font-size: 14px;
            }

            @include mq($h-max-incl-chromebook, max, height) {
                font-size: 1.25rem;
                line-height: normal;
                margin-bottom: 1rem;
            }

            p {
                margin: 0;
            }

            span {
                display: inline-flex;
            }

            .line-1 {
                position: relative;

                &::before {
                    content: '';
                    display: block;
                    width: 100%;
                    height: 100%;
                    background: url('/images/lp/line-1--yellow.svg') no-repeat
                        50% 100%;
                    background-size: 100% auto;
                    position: absolute;
                    bottom: -6px;
                    left: 50%;
                    transform: translateX(-50%);

                    @include mq($w-max-phone, max) {
                        bottom: -3px;
                    }
                }
            }

            .line-2 {
                position: relative;

                &::before {
                    content: '';
                    display: block;
                    width: 100%;
                    height: 100%;
                    background: url('/images/lp/line-2--yellow.svg') no-repeat
                        50% 100%;
                    background-size: 100% auto;
                    position: absolute;
                    bottom: -6px;
                    left: 50%;
                    transform: translateX(-50%);

                    @include mq($w-max-phone, max) {
                        bottom: -3px;
                    }
                }
            }
        }
    }

    &__hero-signup {
        &-wrap {
            display: inline-flex;
            flex-direction: column;
            justify-content: flex-start;

            > a {
                text-decoration: none;
            }
        }

        &-links {
            margin-top: 0.75rem;
            font-weight: 400;
            font-size: 18px;
            color: #ffffff;

            @include mq($w-max-desktop, max) {
                font-size: 16px;
            }

            a {
                color: #ffffff;
                text-decoration: underline;

                &:hover {
                    text-decoration: none;
                }
            }
        }

        .btn-register {
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 72px;
            margin: 0;
            padding: 0 2rem 0 1.25rem;
            text-align: left;
            font-weight: 700;
            font-size: 23px;
            color: #572598;
            border: 0;
            border-radius: 10px;
            background-color: #fff;
            filter: drop-shadow(0px 4px 16px rgba(0, 0, 0, 0.2));
            cursor: pointer;
            transition: all 0.2s;

            @include mq($w-max-desktop, max) {
                height: 66px;
            }

            @include mq($w-max-phone, max) {
                height: 50px;
                padding-right: 1rem;
                font-size: 18px;
                border: 2px solid #fff;
                background-color: transparent;
                color: #fff;
            }

            .icon {
                display: flex;
                margin-left: 1.25rem;

                @include mq($w-max-phone, max) {
                    margin-left: 0.75rem;
                }

                svg {
                    @include mq($w-max-phone, max) {
                        width: 20px;
                        height: 20px;
                    }

                    path {
                        transition: all 0.2s;

                        @include mq($w-max-phone, max) {
                            fill: #fff;
                        }
                    }
                }
            }

            &:hover {
                color: #fff;
                background-color: #f08a4f;

                @include mq($w-max-phone, max) {
                    color: #572598;
                    background-color: #fff;
                }

                .icon {
                    svg {
                        path {
                            fill: #fff;

                            @include mq($w-max-phone, max) {
                                fill: #572598;
                            }
                        }
                    }
                }
            }
        }
    }

    &__hero-video {
        width: 738px;
        height: 496px;
        position: relative;

        @include mq($w-max-desktop, max) {
            width: 566px;
            height: 380px;
        }

        @include mq($w-max-tablet, max) {
            order: 2;
            margin-top: 3rem;
        }

        @include mq($w-max-phone, max) {
            width: 100%;
            height: auto;
        }

        @include mq($w-max-phone, max) {
            margin-top: 2.5rem;
        }
    }

    &__hero-video-clip {
        width: 0;
        height: 0;

        @include mq($w-max-phone, max) {
            display: none;
        }

        .path-1 {
            @include mq($w-max-desktop, max) {
                display: none;
            }
        }

        .path-2 {
            display: none;

            @include mq($w-max-desktop, max) {
                display: block;
            }
        }
    }

    &__hero-video-wrap {
        width: 738px;
        height: 496px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        overflow: hidden;
        -webkit-clip-path: url(#heroVideoClip);
        clip-path: url(#heroVideoClip);

        @include mq($w-max-desktop, max) {
            width: 566px;
            height: 380px;
        }

        @include mq($w-max-phone, max) {
            position: static;
            transform: none;
            width: auto;
            height: auto;
            margin: 0 -1.5rem;
            -webkit-clip-path: none;
            clip-path: none;
        }

        video {
            width: auto;
            height: 100%;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);

            @include mq($w-max-phone, max) {
                width: 100%;
                height: auto;
                position: static;
                transform: none;
                display: block;
                line-height: 1;
            }
        }
    }

    &__hero-video-content {
        width: 738px;
        height: 496px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        @include mq($w-max-desktop, max) {
            width: 566px;
            height: 380px;
        }

        @include mq($w-max-phone, max) {
            width: 100%;
            height: auto;
            position: relative;
            top: auto;
            left: auto;
            transform: none;
        }
    }
}
</style>
